import { makeStyles } from '@material-ui/core/styles';

const styles = (theme) => ({
  appliedTag: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: theme.colorPalette.green_80,
    color: theme.colorPalette.beige_25,
    borderRadius: theme.spacing(4),
    padding: theme.spacing(0, 2),
    height: 26,
    fontSize: 12,
    lineHeight: '16px',
    fontWeight: 600,
    gap: theme.spacing(1)
  }
});

export default makeStyles(styles);
